<template>
  <v-theme-provider light>
    <v-container
      fluid
      class="section-products-summary grey--text text--darken-3"
      light
      id="section-products"
      >
      <v-container class="py-10">
        <v-row class="display-1 font-weight-medium text-center py-5">
          <v-col>
            <p><v-icon class="blink" color="primary">mdi-color-helper</v-icon>Discover our product portfolio</p>
          </v-col>
        </v-row>

        <!-- Superior to 960px  -->
        <v-row v-if="$vuetify.breakpoint.mdAndUp" justify="center">
          <div class="mb-8" v-for="(product, i) in products" :key="i">
            <v-hover
              v-slot:default="{ hover }"
            >
              <v-card
                class="transition-swing"
                max-width="344"
                height="100%"
                :class="[
                  `elevation-${hover ? 12 : 2}`,
                  i === products.length - 1 ? 'mr-0' : 'mr-10',
                ]"
              >
                <v-img :src="product.img" max-height="200px" contain></v-img>
                <v-card-title>
                  {{ product.title }}
                  <v-icon small color="primary" class="ml-1" v-if="product.title === 'Patrowl'">mdi-alert-decagram</v-icon>
                </v-card-title>
                <v-card-subtitle>{{ product.subtitle }}</v-card-subtitle>
                <v-card-text class="pb-0">{{ product.text }}</v-card-text>
                <v-card-actions class="full-height">
                  <v-btn color="primary" text :href="product.to">
                    Explore
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-hover>
          </div>
        </v-row>

        <!-- Inferior to 960px  -->
        <div v-else class="d-flex flex-column align-center">
          <v-col v-for="(product, i) in products" :key="i">
            <v-hover
              v-slot:default="{ hover }"
            >
              <v-card
                class="mx-auto mb-8 transition-swing"
                max-width="344"
                :class="`elevation-${hover ? 12 : 2}`"
              >
                <v-img :src="product.img" height="200px"></v-img>
                <v-card-title>
                  {{ product.title }}
                  <v-icon small color="primary" class="ml-1" v-if="product.title === 'Patrowl'">mdi-alert-decagram</v-icon>
                </v-card-title>
                <v-card-subtitle>{{ product.subtitle }}</v-card-subtitle>
                <v-card-text class="pb-0">{{ product.text }}</v-card-text>
                 <v-card-actions>
                  <v-btn color="primary lighten-2" text :href="product.to">
                    Explore
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-col>
        </div>
      </v-container>
    </v-container>
  </v-theme-provider>
</template>

<script>
export default {
  name: "SecProductsSummary",
  data: () => ({
    products: [
      {
        title: 'Patrowl',
        subtitle: 'Offensive Security as a Service',
        text: 'As advanced EASM and PTaaS platform, Patrowl disrupts the continuous risk evaluation using hyper-automation and cybersecurity experts. It makes it simple to identify, remediate and manage cyber risks on all your exposed assets.',
        to: 'https://patrowl.io',
        img: require('@/assets/screenshots/patrowldashboard/home.png'),
      },
      {
        title: 'PatrowlHears',
        subtitle: 'Vulnerability Intelligence Center',
        text: 'PatrowlHears enables vulnerability watch process for your internal IT assets (OS, middleware, application, Web CMS, Java/.Net/Node library, network devices, IoT, ...). It provides a unified source of vulnerability, exploit and threat Intelligence feeds.',
        to: '/',
        img: require('@/assets/screenshots/patrowlhears/patrowlhears-homepage.png'),
      },
    ],
  }),
  mounted(){
    if (this.$route.query.product != null){
      this.activeTab = this.tabs[this.$route.query.product];
    }
  },
  computed: {
    filteredEngines: function() {
      var filter = this.currentTag;
      return this.engines.filter(function(item) {
          return item.tags.indexOf(filter) !== -1;
      });
    },

  },
  methods: {
    filterEngines: function(tag) {
      this.currentTag = tag;
    }
  }
};
</script>

<style scoped>
.v-tab {
  text-transform: none;
  font-size: large;
}
.product-summary {
  background-color: #F5F5F5;
}
</style>
